import { render, staticRenderFns } from "./CmgMealBuilderItemSelector.vue?vue&type=template&id=5bd8a775&scoped=true&lang=pug"
import script from "./cmg-meal-builder-item-selector.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-item-selector.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealBuilderItemSelector.vue?vue&type=style&index=0&id=5bd8a775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8a775",
  null
  
)

export default component.exports